export const editIcon = {
  data: ` <svg viewBox="0 0 32 32">
            <title>edit</title>
            <path
              opacity="0.498"
              stroke-linejoin="miter"
              stroke-linecap="square"
              stroke-miterlimit="4"
              d="M21 5l6 6"
            ></path>
            <path
              opacity="0.498"
              stroke-linejoin="miter"
              stroke-linecap="round"
              stroke-miterlimit="4"
              d="M21 25h10"
            ></path>
            <path
              opacity="0.498"
              stroke-linejoin="miter"
              stroke-linecap="round"
              stroke-miterlimit="4"
              d="M17 29h14"
            ></path>
            <path
              stroke-linejoin="round"
              stroke-linecap="butt"
              stroke-miterlimit="4"
              d="M26.414 2.414l3.172 3.172c0.781 0.781 0.781 2.047 0 2.828l-20.586 20.586-8 2 2-8 20.586-20.586c0.781-0.781 2.047-0.781 2.828 0z"
            ></path>
          </svg>`,
  name: 'edit',
};
